import Link from 'next/link';
import Icon from '@components/atoms/icon';
import { BodyRegular } from '@components/atoms/typography';

export const InfoAlert = ({
  text,
  dataCy,
  link,
  linkText,
  html
}: {
  text?: string;
  dataCy?: string;
  link?: string;
  linkText?: string;
  html?: string;
}) => (
  <div className="rounded-lg bg-primary-100 flex items-center px-3 py-4">
    <Icon
      name="InfoFilled"
      className="flex-[0_0_auto] text-primary-800 w-5 h-5 mr-2"
    />
    {html ? (
      <BodyRegular
        data-cy={dataCy}
        dangerouslySetInnerHTML={{ __html: html }}
      />
    ) : (
      <BodyRegular data-cy={dataCy}>
        {text}{' '}
        {link ? (
          <Link href={link} className="underline pointer">
            {linkText}
          </Link>
        ) : (
          ''
        )}
      </BodyRegular>
    )}
  </div>
);

export const WarningAlert = ({ text }: { text: string }) => (
  <div className="rounded-lg bg-warning-100 flex items-center px-3 py-4">
    <Icon
      name="Warning"
      className="flex-[0_0_auto] w-5 h-5 mr-2 text-warning-800"
    />
    <BodyRegular textColor="text-warning-800">{text}</BodyRegular>
  </div>
);

export const ErrorAlert = ({
  text,
  handleClose
}: {
  text: string;
  handleClose?: () => void;
}) => (
  <div
    className={`rounded-lg bg-danger-100 flex items-center py-4 relative ${
      handleClose ? 'pl-3 pr-8' : 'px-3'
    }`}
  >
    {handleClose && (
      <Icon
        onClick={handleClose}
        name="Close"
        className="absolute right-2 top-2 pointer"
      />
    )}
    <Icon
      name="Warning"
      className="flex-[0_0_auto] w-5 h-5 mr-2 text-danger-800"
    />
    <BodyRegular textColor="text-danger-800">{text}</BodyRegular>
  </div>
);

export const SuccessAlert = ({ text }: { text: string }) => (
  <div className="rounded-lg bg-success-100 flex items-center px-3 py-4">
    <Icon name="InfoFilled" className="text-success-800 w-5 h-5 mr-2" />
    <BodyRegular>{text}</BodyRegular>
  </div>
);
